<div class="panel-flex">
    <app-dashboard-panel-header
        [title]="'dashboard.panel.alarms.title' | translate"
        [isPreview]="isPreview"
        (onDeleteClicked)="handleDeleteClicked()"
    ></app-dashboard-panel-header>
    <div class="main-content">
        <app-dashboard-alarm-compact
            *ngFor="let alarm of alarms.reverse() | slice: pageStart : pageEnd"
            [alarm]="alarm"
            [currentPage]="currentPage"
            (onSetPage)="onSetPage($event)"
            [pages]="pageCount"
        ></app-dashboard-alarm-compact>
    </div>
    <div class="bottom-ribbon">
        <div data-cy="dashboard-alarms-tab-total-alarms">{{ alarms.length }} total alarms</div>
        <div data-cy="dashboard-alarms-tab-go-to-page-button" (click)="handleGoToPageClicked()" class="highlighted-text">
            {{ "dashboard.panel.labels.navigate-to-page" | translate }}
        </div>
    </div>
</div>
